import { useState, useEffect } from "react"

export const useInfinitePagination = (callApi, callback) => {
  const [page, setPage] = useState(1)
  const [loadingMore, setLoadingMore] = useState(false)
  const [shouldCall, setShouldCall] = useState(true)
  const [calling, setCalling] = useState(false)

  const trackScrolling = () => {
    const footerEstimate = 350
    if (
      window.innerHeight + window.scrollY + footerEstimate >=
        document.body.offsetHeight &&
      shouldCall &&
      !calling
    ) {
      setLoadingMore(true)
      setCalling(true)
      callApi(page + 1).then((response) => {
        setShouldCall(
          !!response.data.next_page_url ||
            !!response.data.artworks?.next_page_url,
        )
        setCalling(false)
        callback(response.data)
        setLoadingMore(false)
        setPage(page + 1)
      })
    }
  }

  useEffect(() => {
    document.addEventListener("scroll", trackScrolling)

    return () => {
      document.removeEventListener("scroll", trackScrolling)
    }
  })

  return {
    loadingMore,
    setPage,
    setShouldCall,
  }
}
